import { lazy, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { SearchFiltersType } from 'app/search/global/type';

const GlobalSearch = lazy(() => import('app/search/global/index'));

interface IProps {
    elementId: string;
    searchParamsId: string;
    showFilters?: boolean;
}

interface ISearchParams {
    query: string;
    filters: SearchFiltersType;
}

export default function SearchWrapper({ props }: { props: IProps }) {
    const [targetEl, setTargetEl] = useState<HTMLElement | null>(null);
    const [searchParams, setSearchParams] = useState<ISearchParams | null>(null);

    useEffect(() => {
        const searchParamsEl = document.getElementById(props.searchParamsId) as HTMLInputElement | null;
        if (!searchParamsEl) return;

        const parseAndSet = () => {
            try {
                const parsedValue: ISearchParams = JSON.parse(searchParamsEl.value);

                setSearchParams(parsedValue);
            } catch (e) {
                console.error('Not possible to read Search Params value', e);
            }
        };

        parseAndSet();

        const observer = new MutationObserver(parseAndSet);
        observer.observe(searchParamsEl, { attributes: true, attributeFilter: ['value'] });

        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        const el = document.getElementById(props.elementId);
        if (el) {
            while (el.firstChild) {
                el.removeChild(el.firstChild);
            }
            setTargetEl(el);
        }
    }, [props.elementId]);

    if (!targetEl) return null;

    return createPortal(
        <GlobalSearch
            searchPattern={searchParams?.query}
            searchFilters={searchParams?.filters}
            showTabs={false}
            showFilters={props.showFilters ?? false}
            parentElement={targetEl}
            appComponent
            key={props.elementId}
        />,
        targetEl,
    );
}
